module.exports = __webpack_public_path__ + "static/img/bg_en.38acd3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_en.png
// module id = SUcv
// module chunks = 1